// Reusable card background: radial gradient corners + SVG ribbon texture.
// Place as first child inside any `group relative overflow-hidden` card.
// Gradient is opacity-15 at rest, full on group-hover; ribbon is opacity-18 → 0.32.
export function CardGlowOverlay() {
  return (
    <>
      <div
        aria-hidden
        className="pointer-events-none absolute -inset-px rounded-xl opacity-15 group-hover:opacity-100 transition-opacity duration-300"
        style={{
          background:
            "radial-gradient(120% 80% at 0% 0%, color-mix(in oklab, var(--accent) 22%, transparent), transparent 55%), radial-gradient(120% 80% at 100% 100%, color-mix(in oklab, var(--primary) 18%, transparent), transparent 60%)",
        }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -top-10 -right-10 h-28 w-28 rounded-full opacity-40 group-hover:opacity-80 transition-opacity duration-300 blur-2xl"
        style={{
          background:
            "radial-gradient(closest-side, color-mix(in oklab, var(--accent) 55%, transparent), transparent 70%)",
        }}
      />
      <svg
        aria-hidden
        className="pointer-events-none absolute inset-0 h-full w-full opacity-[0.18] group-hover:opacity-[0.32] transition-opacity duration-300"
        viewBox="0 0 320 160"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient id="card-ribbon-stroke" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="var(--accent)" />
            <stop offset="100%" stopColor="var(--primary)" />
          </linearGradient>
        </defs>
        <path
          d="M -10 120 C 60 60, 120 150, 200 90 S 320 40, 360 80"
          fill="none"
          stroke="url(#card-ribbon-stroke)"
          strokeWidth="1.2"
        />
        <path
          d="M -10 140 C 70 100, 140 170, 220 120 S 330 80, 360 110"
          fill="none"
          stroke="url(#card-ribbon-stroke)"
          strokeWidth="0.8"
          strokeOpacity="0.7"
        />
        <circle cx="280" cy="32" r="1.6" fill="var(--accent)" />
        <circle cx="40" cy="28" r="1.2" fill="var(--primary)" />
        <circle cx="200" cy="50" r="1" fill="var(--accent)" />
      </svg>
    </>
  );
}
